<template>
  <div class="container">
    <section class="content-header">
      <h1>{{$t('アカウントの削除')}}</h1>
      <p>{{$t('アカウントを削除すると、元に戻すことはできません。お気に入りに保存した記事などはすべて削除されます。')}}</p>
    </section>

    <div class="warning" id="warning" v-if="errors.length">
      <ul>
        <li v-for="(error, index) in errors" :key="index"> {{ error }}</li>
      </ul>
    </div>

    <section class="content-wrap">
      <div class="col-center">
        <button id="removeConfirm" @click="deleteUser">{{$t('アカウントの削除')}}</button>
        <button id="removeCancell" @click="cancelOperation" class="btn-ghost">{{$t('キャンセル')}}</button>
      </div>
    </section>
  </div>
</template>


<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import User from '@/api/user'
import Cookie from 'js-cookie'
import * as constants from '@/constants'


export default {
  data : () => ({
    errors:[],
  }),
  computed:{
    ...mapState(['user']),
    ...mapGetters({
      email: 'user/email',
      accessToken: 'user/accessToken'
    }),
  },
  methods:{
    cancelOperation(){
      this.$router.push('/settings')
    },
    deleteUser(){
      this.errors = []
      let bodyParams = {
        email: this.$store.state.user.email,
        accessToken: this.$store.state.user.accessToken
      }

      User.deleteUser(bodyParams)
      .then((response) => {
        Cookie.remove('_mua_c_aut_ls_t')
        Cookie.remove('_mua_c_aut_us_dtl')
        Cookie.remove('_mua_c_aut_em')
        let provider = this.$store.state.userMeta.provider
        // this.$store.dispatch('logout')
        // console.log(process.env.COOKIES_DOMAIN)
        this.$store.dispatch('logout').then((result) => {
          Cookie.remove('CognitoIdentity.Provider', { domain: process.env.COOKIES_DOMAIN })
          Cookie.remove('CognitoIdentity.accessToken', { domain: process.env.COOKIES_DOMAIN })
          Cookie.remove('CognitoIdentity.cognitoIdentiyId', { domain: process.env.COOKIES_DOMAIN })
          Cookie.remove('CognitoIdentity.sns_registration', { domain: process.env.COOKIES_DOMAIN })
          Cookie.remove('CognitoIdentity.s_stamp', { domain: process.env.COOKIES_DOMAIN })
          if(provider === 'accounts.google.com' || provider === 'graph.facebook.com'){
            Cookie.set('ulso', 'true', { domain: process.env.COOKIES_DOMAIN });
          }

          // console.log(result)
          this.$swal({
            text: this.$t('アカウントの削除が完了しました。'),
            type: 'success'
          }).then(()=>{
            window.location.href = process.env.MATCHA_MAIN_SITE+ '/' + this.$store.state.languageName
          })          
        }).catch((err) =>{
          // console.log(err)
          this.$swal({
            text: this.$t('Something going to be wrong! Please try later.'),
            type: 'warning'
          })
        })
        // window.location.href = constants.MATCHA_SITE + this.$store.state.languageName
      }).catch((error) => {
        // console.log(error)
        var atError = this.getNestedObject(error, ['errors', 'message', 0, 'accessToken', 0]);
        var mailError = this.getNestedObject(error, ['errors', 'message', 0, 'email', 0]);
        if(atError !== undefined){
          this.errors.push(this.$t(atError))
        }
        if(mailError !== undefined){
          this.errors.push(this.$t(mailError) || mailError)
        }
        if(atError === undefined && mailError === undefined){
          this.errors.push(this.$t('undefined'))
        }
        
      })
    },
    getNestedObject: function(nestedObj, pathArr){
      return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    }
  },


  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('アカウントの削除') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.$store.state.languageName
      },
    }
  },    

}

</script>



// WEBPACK FOOTER //
// src/pages/settings/accountdeleteconfirm.vue